import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';

@Injectable()
export class MaterialStackContainerService {
  getMaterialDetails(assignmentId: any): Observable<AmberResponse<MaterialInfo>> {
    const url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.content.details.api + '/' + assignmentId;
    return this.requestService.get(url);
  }

  constructor(
    private configService: ConfigService,
    private requestService: RequestService,
  ) { }

}

export class AmberResponse<T> {
  data: T;
  error: string;
  status: string;
  flags: {
    list: boolean,
    size: number
  }
}

export class MaterialInfo {
  material: {
    id: string;
    name: string;
    type: string;
    availableUntil: string;
    expired: boolean;
    course: string;
    productVariant: { deliveryFormat: string, languageValue: string };
    smallImageUri: string;
  };
  learnerDeliverables: any[];
  eLearningCertificates: any[];


}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/material-stack-container/material-stack-container.service.ts